/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import {
  Container,
  Grid,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { globalColors } from "../../../../../../../_metronic/_assets/sass/custom/globalColors";
import { ReactComponent as downloadIcon } from "../../../../../../assets/custom-icons/download.svg";
import { ReactComponent as paperClipIcon } from "../../../../../../assets/custom-icons/paper-clip.svg";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../../../../partials/datatable/styles";
import { AppAPIService } from "../../../../../../services/AppAPIService";

import { SvgIcon } from "@material-ui/core";
import DocumentStatusEnum from "../../../../../../enums/DocumentStatusEnum";
import { UploadModal } from "../../../Lawsuit/components/Document/components/UploadModal/UploadModal";
import { ConfirmModal } from "../../../Parametrizacao/Components/Processual/components/ConfirmModal";
import {
  getDisplayFromStatusHelper,
  getDisplayFromStatusHelperToAproveRejectDocuments,
  shouldShowDeclineButton,
} from "../../helpers/getDisplayFromStatusHelper";
import { getLabelAndColorFromStatusHelper } from "../../helpers/getLabelAndColorFromStatusHelper";

import { ReactComponent as approvedIcon } from "../../../../../../assets/custom-icons/check-circle.svg";
import { ReactComponent as informationIcon } from "../../../../../../assets/custom-icons/information-circle.svg";
import { ReactComponent as deniedIcon } from "../../../../../../assets/custom-icons/x-circle.svg";
import { USER_ROLES } from "../../../../../../enum/UserRoles";
import CrudActions from "../../../../../../partials/datatable/CrudActions";
import RejectingDocumentModal from "../UserDocumentsDataTable/components/CreateModal/RejectingDocumentModal";
import RejectingDocumentModalInfo from "../UserDocumentsDataTable/components/CreateModal/RejectingDocumentModalInfo";
import Loading from "../../../../pages/../../home/components/Loading";
import { useMediaQuery } from "@mui/material";
import UserRole from "../../../../../../enums/UserRole";
import { useSelector } from "react-redux";

export const LawsuitDocumentTable = (props) => {
  let api = AppAPIService.getInstance();
  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
  const [confirmedDelete, setConfirmedDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [documentOptions, setDocumentOptions] = useState([]);
  const [document, setDocument] = useState(null);
  const [showUpload, setShowUpload] = useState(false);
  const authUser = useSelector((state) => state.auth.user);
  const userRole = authUser?.role;
  const srollableTable = useMediaQuery("(max-width: 768px)");

  const history = useHistory();

  const [filesList, setFilesList] = useState([]);

  const getDocumentOptions = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.makeHttpRequest({
        url: `/document/list-paginated`,
        method: "GET",
      });
      const documentOptionsFromApi = response.data.map((document) => {
        return { value: document.id, label: document.name };
      });
      setDocumentOptions(documentOptionsFromApi);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [api]);
  useEffect(() => {
    getDocumentOptions();
  }, [getDocumentOptions, props.reload]);

  const tableHeaders = [
    "Ações",
    "Documento",
    "Arquivo",
    "Data de modificação",
    "Status",
  ];
  const [documentList, setDocumentList] = useState();

  const getDocumentList = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.makeHttpRequest({
        url: `/document/list-paginated`,
        params: {
          lawsuitId: props.lawsuitId,
        },
        method: "GET",
      });
      if (userRole === UserRole.CLIENT) {
        setDocumentList(response.data.filter((document) => document.active));
      } else {
        setDocumentList(response.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [api, props.lawsuitId, userRole]);

  const [idToDelete, setIdToDelete] = useState(null);
  const [documentData, setDocumentData] = useState(null);
  const handleConfirmDelete = useCallback(
    async (id) => {
      try {
        setLoading(true);
        const result = await api.makeHttpRequest({
          method: "DELETE",
          url: `/document/${id}`,
        });

        if (result?.HttpStatus == 404) {
          Swal.fire("Erro!", "Erro ao deletar documento.", "error");
          return;
        }

        if (result?.HttpStatus !== 200) {
          Swal.fire("Erro!", "Erro ao deletar documento.", "error");
          return;
        }

        props.setReload(!props.reload);
        setLoading(false);
        Swal.fire(
          "Sucesso!",
          "Documento deletado com sucesso.",
          "success"
        ).then(() => {
          getDocumentList();
        });
      } catch (e) {
        Swal.fire("Erro!", "Erro ao deletar documento.", "error");
      }
      setConfirmedDelete(false);
      setLoading(false);
    },
    [api, getDocumentList, props]
  );

  useEffect(() => {
    getDocumentList();
  }, [getDocumentList, props.reload]);

  const handleDeleteRecord = (id) => {
    setIdToDelete(id);
    setShowConfirmDeleteModal(true);
  };

  useEffect(() => {
    if (confirmedDelete) {
      handleConfirmDelete(idToDelete);
    }
  }, [confirmedDelete, handleConfirmDelete, idToDelete]);

  const handleOpenUploadModal = useCallback(
    (row) => {
      setShowUpload(true);
      setDocumentData({
        documentCategoryId: row.documentCategoryId,
        documentId: row?.id,
        lawsuitId: row?.lawsuitId,
        userId: props.userId,
      });
    },
    [props.userId]
  );

  const handleDownload = useCallback(
    async (filesKeys, row) => {
      if (!filesKeys || filesKeys.length === 0) {
        Swal.fire("Desculpe!", "Não contém arquivo!", "error");
      } else {
        handleOpenUploadModal(row);
        setFilesList(filesKeys);
      }
    },
    [handleOpenUploadModal]
  );

  const handleAttach = useCallback(
    async (filesKeys, row) => {
      if (filesKeys && filesKeys.length > 0) {
        setFilesList(filesKeys);
      }
      handleOpenUploadModal(row);
    },
    [handleOpenUploadModal]
  );

  const approveDocument = useCallback(
    async (id) => {
      try {
        setLoading(true);
        const result = await api.makeHttpRequest({
          method: "PUT",
          url: `/document/update-status/${id}`,
          data: {
            typeDoc: "lawsuit",
            status: DocumentStatusEnum.COMPLETED,
          },
        });

        props.setReload(!props.reload);

        Swal.fire(
          "Sucesso!",
          "Documento aprovado com sucesso.",
          "success"
        ).then(() => {
          getDocumentList();
        });
      } catch (e) {
        Swal.fire("Erro!", "Erro ao aprovar documento.", "error");
      } finally {
        setLoading(false);
      }
    },
    [api, getDocumentList, props]
  );

  const [observationReject, setObservationReject] = useState("");
  const [rejectingDocumentId, setRejectingDocumentId] = useState(null);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [showRejectModalInfo, setShowRejectModalInfo] = useState(false);
  let crudActions =
    userRole === USER_ROLES.COLLABORATOR
      ? ["toggle"]
      : ["toggle", "delete"];

  const handleConfirmChangeStatus = useCallback(
    async (obj) => {
      try {
        setLoading(true);
        await api.makeHttpRequest({
          method: "PATCH",
          url: `/document/toggle/${obj.id}`,
        });
        setLoading(false);
        props.setReload(!props.reload);

        const documentStatus = !obj.active ? "ativado" : "desativado";

        Swal.fire({
          title: "Sucesso!",
          text: `Documento ${documentStatus} com sucesso!`,
          icon: "success",
          cancelButtonText: "Sair",
        });
      } catch (e) {
        Swal.fire("Erro!", "Erro ao alterar status do documento.", "error");
      } finally {
        setLoading(false);
        if (props?.handleGetParent) {
          props.handleGetParent();
        }
        getDocumentList();
      }
    },
    [api, getDocumentList, props]
  );

  const rejectDocument = useCallback(
    async (id) => {
      try {
        setLoading(true);
        const result = await api.makeHttpRequest({
          method: "PUT",
          url: `/document/update-status/${id}`,
          data: {
            status: DocumentStatusEnum.REJECTED,
            observation: observationReject,
          },
        });

        setLoading(false);
        props.setReload(!props.reload);

        Swal.fire(
          "Sucesso!",
          "Documento rejeitado com sucesso.",
          "success"
        ).then(() => {
          getDocumentList();
        });
      } catch (e) {
        Swal.fire("Erro!", "Erro ao rejeitar documento.", "error");
      } finally {
        setLoading(false);
      }
    },
    [api, getDocumentList, observationReject, props]
  );

  const [status, setStatus] = useState(null);
  return (
    <Container
      style={{
        boxShadow: "none",
        padding: 0,
        margin: 0,
      }}
      maxWidth="xlx"
    >
      {loading ? <Loading isLoading={loading} /> : null}
      <RejectingDocumentModal
        open={showRejectModal}
        handleOpen={setShowRejectModal}
        observationReject={observationReject}
        setObservationReject={setObservationReject}
        rejectingDocumentId={rejectingDocumentId}
        rejectDocument={rejectDocument}
      />

      <RejectingDocumentModalInfo
        open={showRejectModalInfo}
        handleOpen={setShowRejectModalInfo}
        observationReject={observationReject}
      />
      <ConfirmModal
        open={showConfirmDeleteModal}
        handleOpen={setShowConfirmDeleteModal}
        handleConfirm={handleConfirmDelete}
        setConfirmedDelete={setConfirmedDelete}
        id={idToDelete}
        setId={setIdToDelete}
      />
      <UploadModal
        open={showUpload}
        handleOpen={setShowUpload}
        dados={documentData}
        setReload={props.setReload}
        reload={props.reload}
        handleGetDocuments={getDocumentList}
        handleGetParent={props?.handleGetParent}
        filesList={filesList}
      />
      <Grid
        xl={12}
        lg={12}
        md={12}
        sm={12}
        xs={12}
        container
        style={{
          padding: 0,
        }}
      >
        <Container
          maxWidth="xxl"
          style={{
            boxShadow: "none",
            border: "1px solid #e0e0e0",
            borderRadius: "5px",
            padding: 0,
            textAlign: "left",
            maxWidth: srollableTable ? "calc(100vw - 70px)" : "100%",
            overflowX: srollableTable ? "scroll" : "hidden",
          }}
        >
          <Table
            className="table"
            style={{
              marginTop: "0px",
              marginBottom: "0px",
              padding: "0px",
              borderCollapse: "collapse",
              borderSpacing: "0px",
              width: "100%",
            }}
          >
            <TableHead
              style={{
                backgroundColor: globalColors.secondaryColor3,
              }}
            >
              <TableRow
                style={{
                  textAlign: "left",
                  backgroundColor: globalColors.secondaryColor3,
                }}
              >
                {tableHeaders.map((header, index) => (
                  <StyledTableCell
                    key={index}
                    style={{
                      textAlign: ["Data de modificação", "Status"].includes(
                        header
                      )
                        ? "center"
                        : "left",
                      backgroundColor: globalColors.secondaryColor3,
                      border: "none ",
                    }}
                  >
                    {header}
                  </StyledTableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody
              style={{
                textAlign: "left",
                backgroundColor: globalColors.colorWhite,
              }}
            >
              {documentList?.map((row) => (
                <StyledTableRow
                  key={row.id}
                  style={{
                    backgroundColor:
                      row.id % 2 !== 0 ? "#fffff" : "rgba(225, 222, 219, 0.25)",
                  }}
                >
                  <StyledTableCell
                    style={{
                      color: globalColors.backgroundColor2,
                      padding: "4px 10px",
                      textAlign: "left",
                      width: "200px",
                    }}
                  >
                    <div
                      style={{
                        padding: 0,
                        margin: 0,
                        justifyContent: "flex-start",
                        alignItems: "center",
                        color: "red",
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <div
                        style={{
                          margin: 0,
                          padding: 0,
                          display:
                            userRole === USER_ROLES.ADMIN ||
                            userRole === USER_ROLES.COLLABORATOR
                              ? "flex"
                              : "none",
                          justifyContent: "center",
                        }}
                      >
                        <CrudActions
                          actions={crudActions}
                          module="processo"
                          onConfirmChangeStatus={handleConfirmChangeStatus}
                          onConfirmDelete={handleConfirmDelete}
                          id={row.id}
                          obj={row}
                          titleMessageDelete={""}
                          addMessage={"Deseja deletar esse documento?"}
                        />
                      </div>
                      {row.status !== DocumentStatusEnum.COMPLETED && (
                        <SvgIcon
                          component={paperClipIcon}
                          onClick={() => {
                            handleAttach(
                              row?.files.map((file) => ({
                                name: file.name,
                                fileKey: file.fileKey,
                                id: file?.id,
                                documentId: row?.id,
                              })),
                              row
                            );
                          }}
                          style={{
                            width: "20px",
                            height: "20px",
                            color: globalColors.backgroundColor2,
                            fill: "transparent",
                            cursor: "pointer",
                            marginRight: "10px",
                            display: "block",
                          }}
                          title={"Anexar documento"}
                        />
                      )}
                      <SvgIcon
                        component={approvedIcon}
                        onClick={() => {
                          approveDocument(row.id);
                        }}
                        style={{
                          width: "20px",
                          height: "20px",
                          color: globalColors.backgroundColor2,
                          marginRight: "10px",
                          fill: "transparent",
                          cursor: "pointer",
                          display:
                            getDisplayFromStatusHelperToAproveRejectDocuments(
                              row.status,
                              authUser
                            ),
                        }}
                        title={"Aprovar documento anexado"}
                      />
                      <SvgIcon
                        component={deniedIcon}
                        onClick={() => {
                          setObservationReject("");
                          setRejectingDocumentId(row.id);
                          setShowRejectModal(true);
                        }}
                        style={{
                          width: "20px",
                          height: "20px",
                          color: globalColors.backgroundColor2,
                          fill: "transparent",
                          cursor: "pointer",
                          display: shouldShowDeclineButton(
                            row.status,
                            authUser
                          ),
                          margin: "0",
                          marginRight: "10px",
                        }}
                        title={"Rejeitar documento anexado"}
                      />
                      <SvgIcon
                        component={informationIcon}
                        onClick={() => {
                          setObservationReject(row.observation);
                          setShowRejectModalInfo(true);
                        }}
                        style={{
                          width: "20px",
                          height: "20px",
                          color: globalColors.backgroundColor2,
                          fill: "transparent",
                          cursor: "pointer",
                          display:
                            row.status === DocumentStatusEnum.REJECTED
                              ? "block"
                              : "none",
                          marginRight: "10px",
                        }}
                        title={"Informações sobre a rejeição"}
                      />
                      {row.files?.length > 0 && (
                        <SvgIcon
                          component={downloadIcon}
                          onClick={() => {
                            handleDownload(
                              row?.files.map((file) => ({
                                name: file.name,
                                fileKey: file.fileKey,
                                id: file?.id,
                                documentId: row?.id,
                              })),
                              row
                            );
                          }}
                          style={{
                            width: "20px",
                            height: "20px",
                            color: globalColors.backgroundColor2,
                            fill: "transparent",
                            cursor: "pointer",
                          }}
                          title={"Baixar documento anexado"}
                        />
                      )}
                    </div>
                  </StyledTableCell>
                  <StyledTableCell
                    style={{
                      padding: "4px 10px",
                      textAlign: "left",
                    }}
                  >
                    {row.documentCategory.name}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{
                      padding: "4px 10px",
                      textAlign: "left",
                    }}
                  >
                    {row.files.length > 1
                      ? "Arquivos enviados"
                      : row.files.length === 1
                      ? row.files[0].name
                      : "Não enviado"}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{
                      padding: "4px 10px",
                      textAlign: "center",
                    }}
                  >
                    {new Date(row.updatedAt).toLocaleDateString("pt-BR")}
                  </StyledTableCell>
                  <StyledTableCell
                    style={{
                      padding: "4px 10px",
                      textAlign: "center",
                      width: "100px",
                    }}
                  >
                    <Typography
                      style={{
                        backgroundColor: getLabelAndColorFromStatusHelper(
                          row.status
                        ).color,
                        display: "inline-block",
                        padding: "4px 6px",
                        margin: "0 4px",
                        borderRadius: "4px",
                        fontWeight: "500",
                        color: getLabelAndColorFromStatusHelper(row.status)
                          .textColor,
                      }}
                    >
                      {getLabelAndColorFromStatusHelper(row.status).label}
                    </Typography>
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </Container>
      </Grid>
    </Container>
  );
};
